import { render, staticRenderFns } from "./ReadingTime.vue?vue&type=template&id=b7b7539c&scoped=true"
import script from "./ReadingTime.vue?vue&type=script&lang=js"
export * from "./ReadingTime.vue?vue&type=script&lang=js"
import style0 from "./ReadingTime.vue?vue&type=style&index=0&id=b7b7539c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b7539c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ReadingTime.vue
// module id = 139
// module chunks = 0